// Node modules
import { IEvent } from "@quest/adapter-interface";
import { clone, detectDeviceEnvironmentConstants, Graphics, ingenuity, ISpineData, SpineBase } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { BigWinView, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class BigWinViewGame extends BigWinView {
    private baseGameMask: Graphics;

    /*
    Override resize to update resizing
    */
    public resize(evt: IEvent): void {
        super.resize(evt);
        if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            this.y = innerHeight / 2;
            this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
            this.scale.set(1);

            const bigwinCont = this.getContainerByID("bigWinMainContainer")
            bigwinCont.pivot.set(640, 900); // provided hard coded value as the spine size changes while animating , so can't use width/2 
            if (ingenuity.deviceEnv.getIsIpad()) {
                bigwinCont.scale.set(ingenuity.deviceEnv.getPortraitMaxScale());
            } else {
                bigwinCont.scale.set(ingenuity.deviceEnv.getPortraitScale());
            }
            if (this.bigWinMainContainer) {
                ((this.bigWinMainContainer).mask as Graphics) = null;
            }
        }
        else {
            let scale = 0;
            this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER;
            scale = Math.min((innerHeight / ingenuity.configData.height), (innerWidth / ingenuity.configData.width));
            this.scale.set(scale);
            this.getContainerByID("bigWinMainContainer").pivot.set(0);
            this.getContainerByID("bigWinMainContainer").scale.set(1);
            this.baseGameMask = this.getShapeById("baseGameMask") as Graphics;
            if (this.bigWinMainContainer) {
                (this.bigWinMainContainer.mask as Graphics) = this.baseGameMask;
            }
        }
        //For both Desktop & Landscape
        if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
            const heightScale = innerHeight / ingenuity.configData.height;
            this.scaleComponents();
            this.scale.set(heightScale);
        }


    }

    /*Override initialiseElements to call initializeComponents*/
    protected initialiseElements(): void {
        super.initialiseElements();
        this.initializeComponents();


    }
    // Add to create spine
    public createBigWinSpine(spineId: string): SpineBase {
        let bigWinObj: ISpineData = clone(this.json[spineId]);
        bigWinObj.type = "spine";
        let bigWinSpine: SpineBase = this.createSpine(bigWinObj);
        bigWinSpine.visible = false;
        return bigWinSpine;
    }

}



